import { AccordionContainer } from './styled';
export function Accordion(props) {
    const { children, header, defaultOpenValue = [] } = props;
    const defaultValue = Array.isArray(defaultOpenValue) ? defaultOpenValue : [defaultOpenValue];
    return (<AccordionContainer multiple defaultValue={defaultValue}>
      {header}
      {children}
    </AccordionContainer>);
}
